import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CustomValidator } from 'src/app/helpers/custom.validator';
import { AuthenticationService } from 'src/app/services/authentication.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-setpassword',
  templateUrl: './setpassword.component.html'
})
export class SetpasswordComponent implements OnInit {
  setPasswordForm!: FormGroup;
  dataLoading = true;

  loading = false;
  msgObj = { msg: '', type: '' };
  urlExpired = false;
  hidePassword = true;
  hideConfPassword = true;

  userId!: string | null;
  token!: string | null;
  linkValid = true;
  firstTime = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.authenticationService.clearUserData();
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['New']) {
        this.firstTime = params['New'] == 'true' ? true : false;
      }
    });
    this.activatedRoute.paramMap.subscribe(params => {
      this.userId = params.get('userid');
      this.token = params.get('token');
      if (this.userId && this.token) {
        this.dataLoading = true;
        this.authenticationService.checkResetPasswordLink(this.userId, this.token).subscribe(
          data => {
            this.dataLoading = false;
            this.linkValid = data as boolean;
            if (data) { this.initForm(); }
          },
          error => {
            this.dataLoading = false;
            this.linkValid = false;
          }
        );
      } else {
        this.linkValid = false;
      }
    });
  }
  hasError(controlName: string, errorName: string) {
    return this.setPasswordForm.controls[controlName].hasError(errorName);
  }

  initForm() {
    this.setPasswordForm = new FormGroup({
        password: new FormControl(null, [
          Validators.required,
          Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?#&._-]).{8,}$')
        ]),
        confirmPassword: new FormControl(null, [
          Validators.required,
          Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?#&._-]).{8,}$')
        ])
      },
      [CustomValidator.MatchValidator('password', 'confirmPassword')]
    );
  }
  get passwordMatchError() {
    return (
      this.setPasswordForm.getError('mismatch') &&
      this.setPasswordForm.get('confirmPassword')?.touched
    );
  }

  resetPassword() {
    if (this.userId && this.token) {
      if (this.setPasswordForm.valid) {
        this.loading = true;
        this.authenticationService.resetPassword(
          this.userId, this.token,
          this.setPasswordForm.controls['password'].value,
          this.firstTime
        ).subscribe(
          data => {
            this.loading = false;
            this.msgObj.msg = this.translate.instant('auth.Password-updated-successfully');
            this.msgObj.type = 'success';
            Swal.fire({
              title: this.translate.instant('swalMsg.Success'),
              text: this.translate.instant('auth.Password-updated-successfully'),
              icon: 'success',
              confirmButtonText: this.translate.instant('swalMsg.Ok')
            }).then((result) => {
              this.router.navigate(['/logout']);
            });
          },
          error => {
            this.loading = false;
            this.msgObj.msg = error.detail;
            this.msgObj.type = 'danger';
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: error.detail,
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok')
            })
            // this.urlExpired = true;
          });
      }
    }
  }

}
